<script lang="ts">
  import { browser } from '$app/environment';
  import { CHILD_DIRECTED_TREATMENT } from '$lib/constants/persistent-store';
  import { getCookie } from '$lib/utils/cookie';
  import Logger from '$lib/utils/logger';
  import { PersistentStore } from '$lib/utils/persistent-store';
  if (browser) {
    Logger.log('CHILD_DIRECTED_TREATMENT', typeof PersistentStore.get(CHILD_DIRECTED_TREATMENT));
    window['ga-disable-G-ZBLD0MNCJM'] = PersistentStore.get(CHILD_DIRECTED_TREATMENT) ?? false;
  }
</script>

<svelte:head>
  <script
    defer
    fetchpriority="low"
    src="https://www.googletagmanager.com/gtag/js?id=G-ZBLD0MNCJM"
  ></script>
  <script>
    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag('js', new Date());
      gtag('config', 'G-ZBLD0MNCJM');
    }
  </script>
</svelte:head>
